const assessmentTranslations = {
  short: {
    notProcessedReason: {
      label: "Warum nicht",
      values: {
        clientNotAvailable: "Mandantschaft nicht erreicht",
        clientNumberIncorrect: "Falsche Rufnummer",
        clientCancelled: "Mandantschaft hat Termin abgesagt",
        lawyerUnavailable: "Ich konnte nicht teilnehmen",
      },
    },
    followUpAction: {
      label: "Weitere Tätigkeit",
      values: {
        counsultation: "Weitere kurze Beratung",
        additionalActions: "Außergerichtliches Schreiben",
        documentCheck: "Prüfung von Dokumenten",
        courtProcess: "Anwaltliche Betreuung und ggf. Prozess",
      },
    },
  },
};

export default assessmentTranslations;
